import React, {Component, PropTypes} from 'react';
import "./style.scss"
import buttonInstagram from '../../assets/button_instagram.png'
import buttonVk from '../../assets/button_vk.png'
import buttonEmail from '../../assets/button_email.png'

class Footer extends Component {

	render() {
		return (
			<div className="footer">
				<a href="https://www.instagram.com/Pash237/"><img className="footer-button" src={buttonInstagram}/></a>
				<a href="https://vk.com/pavel.alexeev"><img className="footer-button" src={buttonVk}/></a>
				<a href="mailto:pasha.alexeev@gmail.com"><img className="footer-button" src={buttonEmail}/></a>
				<p className="footer-copyright">PAVEL ALEXEEV © {new Date().getFullYear()}</p>
			</div>
		);
	}

}

export default Footer;
